export default {"src":"/_next/static/image/public/images/Green_success.69ca8fbc7c731cd6e77eb15cad14408f.svg","height":16,"width":17};